import React from 'react';
import { BsDownload } from 'react-icons/bs';
import { useWindowDimensions } from '../../../utils';
import { OnestBoldDefault, OnestNormalDefault } from '../../styled/TextComponents';
import { color_white, color_red_default, color_grey_ultra_light } from '../../../constants/colors';
import Config from '../../../Config';
import { useI18n } from '../../../i18n/I18nProvider';
import {
    getLocalizedLibraryName,
    getLocalizedLibraryPath,
} from '../../../i18n/localizedContent';

const ViewLibraryFileBlock = ({ libraryFileData }) => {
    const { locale } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    const displayName = getLocalizedLibraryName(libraryFileData, locale) || libraryFileData.name;
    const filePath = getLocalizedLibraryPath(libraryFileData, locale) || libraryFileData.index_html_path;

    return (

            <div 
             onClick={() => {
                window.open(
                    Config.CLOUD_ADDR + '/' + filePath, 
                    '_blank', 
                    'noopener,noreferrer'
                    );
            }}
            style={{
                width: screenWidth > 530 ? 190 : screenWidth - 80,
                height: screenWidth > 530 ? 226 : "auto",
                borderRadius: 20,
                display: "flex",
                flexDirection: "column",
                padding: 12,
                gap: 25,
                backgroundColor: color_white,
                alignItems: "center",
                cursor: "pointer",
            }}>
                <img 
                    style={{
                        width: screenWidth > 530 ? 190 : screenWidth - 80,
                        height: screenWidth > 530 ? 160 : "auto",
                        borderRadius: 10,
                        objectFit: "cover",
                        backgroundColor: color_grey_ultra_light,
                    }} 
                    src={Config.CLOUD_ADDR + '/' + libraryFileData.image_path} 
                    alt={"fileImage"} 
                />
                
                <div style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 25,
                
                }}>
                    <OnestNormalDefault>{displayName}</OnestNormalDefault>
                    {libraryFileData.is_download && (
                        <div 
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                const link = document.createElement("a");
                                link.href = Config.CLOUD_ADDR + '/' + filePath;
                                const extension = String(filePath || "").split('.').pop();
                                link.download = `${displayName}.${extension}`;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }}
                        >
                            <BsDownload
                                style={{
                                    color: color_red_default,
                                    fontSize: 25
                                }} 
                            />
                        </div>
                    )}
                </div>
            </div>
        
    );
};

export default ViewLibraryFileBlock;